  import axios from 'axios';

  const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://aranyaka-crm-backend-production.up.railway.app/api",
  timeout: 15000,
});

  // Attach token to every request
  api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  // Auto-logout on 401
  api.interceptors.response.use(
    res => res,
    err => {
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      return Promise.reject(err);
    }
  );

  // ── Auth ──────────────────────────────────────────────────────────────────
  export const login = (email, password) =>
    api.post('/auth/login', { email, password });

  export const getMe = () => api.get('/auth/me');

  export const changePassword = (currentPassword, newPassword) =>
    api.put('/auth/change-password', { currentPassword, newPassword });

  export const getUsers = () => api.get('/auth/users');

  export const createUser = (data) => api.post('/auth/register', data);

  export const updateUser = (id, data) => api.put(`/auth/users/${id}`, data);

  // ── Leads ─────────────────────────────────────────────────────────────────
  export const getLeads = (page = 1, limit = 100, filters = {}) =>
  api.get('/leads', {
    params: {
      page,
      limit,
      ...filters
    }
  });

export const getPipelineLeads = (
  page = 1,
  limit = 100,
  filters = {}
) =>
  api.get('/leads/pipeline/list', {
    params: {
      page,
      limit,
      search: filters.search || ''
    }
  });

export const getLead = (id) => api.get(`/leads/${id}`);

  export const getLeadQualifyingQuestions = (leadId) =>
  api.get(`/leads/${leadId}/qualifying-questions`);

export const saveLeadQualifyingAnswer = (
  leadId,
  questionId,
  optionId
) =>
  api.put(
    `/leads/${leadId}/qualifying-questions/${questionId}`,
    {
      option_id: Number(optionId),
    }
  );

  export const getDroppedLead = (id) => api.get(`/leads/dropped/${id}`);

  export const createLead = (data) => api.post('/leads', data);

  export const updateLead = (id, data) => api.put(`/leads/${id}`, data);

  export const bulkImportLeads = (leads) => api.post('/leads/bulk', { leads });

  export const logFollowUp = (id, description, type) =>
    api.post(`/leads/${id}/followup`, { description, activity_type: type });

  export const dropLead = (
  id,
  reason,
  comment
) =>
  api.post(`/leads/${id}/drop`, {
    reason,
    comment,
  });

  export const getLeadHistory = (id) =>
    api.get(`/leads/${id}/history`);

  export const getDroppedLeads = (
  page = 1,
  limit = 100,
  filters = {}
) =>
  api.get("/leads/dropped/list", {
    params: {
      page,
      limit,
      ...filters,
    },
  });


    

  // ── Calls ─────────────────────────────────────────────────────────────────
  export const initiateCall = (lead_id, note) =>
    api.post('/calls/click-to-call', { lead_id, note });

  export const endCall = (call_id, duration_seconds, note) =>
    api.put(`/calls/${call_id}/end`, { duration_seconds, note });

  export const getCallsForLead = (lead_id) =>
    api.get(`/calls/lead/${lead_id}`);

  export const getCallStats = () => api.get('/calls/stats');

  // ── Tasks ─────────────────────────────────────────────────────────────────
  export const getTasksForLead = (lead_id) =>
    api.get(`/tasks/lead/${lead_id}`);

  export const createTask = (data) => api.post('/tasks', data);

  export const completeTask = (id) => api.put(`/tasks/${id}/done`);

  export const deleteTask = (id) => api.delete(`/tasks/${id}`);

  export const getMyTasks = () => api.get('/tasks/mine');

  // ── Reports ───────────────────────────────────────────────────────────────
  export const getDashboard = () => api.get('/reports/dashboard');

  export const getPipelineReport = () => api.get('/reports/pipeline');

  export const getForecastReport = () => api.get('/reports/forecast');

  export const getSalespersonReport = () => api.get('/reports/salesperson');
  export const getDailySalesPerformance = (filters = {}) =>
  api.get('/reports/daily-sales-performance', {
    params: filters,
  });
  export const getDailyFollowUp = (filters = {}) =>
  api.get('/reports/daily-follow-up', {
    params: filters,
  });

export const getDailyFollowUpDetails = (filters = {}) =>
  api.get('/reports/daily-follow-up/details', {
    params: filters,
  });

export const getSourceReport = () => 
  api.get('/reports/source');

export const getStageReport = (params = {}) =>
  api.get('/reports/stage-report', { params });

export const getStageAging = (params = {}) =>          
  api.get('/reports/stage-aging', { params }); 

export const getStageAgingDetails = (params = {}) =>       
  api.get('/reports/stage-aging/details', { params });

export const getFollowUpGap = (params = {}) =>
  api.get('/reports/follow-up-gap', { params });

export const getFollowUpGapLeads = (params = {}) =>
  api.get('/reports/follow-up-gap/leads', { params });

export const getStageTimeReport = () => 
  api.get('/reports/stage-time');

export const getCallStatsReport = () => 
  api.get('/calls/stats');

  // ── Deals ───────────────────────────────────────────────────────────────

  export const createDeal = (data) =>
    api.post("/deals", data);

  export const getDeals = (status = "Active") =>
    api.get("/deals", {
      params: { status }
    });


  export const getActiveDeals = (
  page = 1,
  limit = 50,
  filters = {}
) =>
  api.get("/deals", {
    params: {
      status: "Active",
      page,
      limit,
      search: filters.search || undefined,
      stage: filters.stage || undefined,
      filterStatus: filters.status || undefined,
      assigned_to: filters.assigned_to || undefined,
      source: filters.source || undefined,
    },
  });

    export const getLostDeals = (page = 1, limit = 50) =>
    api.get("/deals", {
      params: {
        status: "Lost",
        page,
        limit,
      },
    });

  export const getWonDeals = (page = 1, limit = 50) =>
    api.get("/deals", {
      params: {
        status: "Won",
        page,
        limit,
      },
    });

    export const getDealDashboard = (filters = {}) =>
  api.get("/deals/dashboard", {
    params: {
      assigned_to:
        filters.assigned_to || undefined,
      source:
        filters.source || undefined,
    },
  });

    export const getDealById = (id) =>
    api.get(`/deals/${id}`);

    export const updateDeal = (id, data) =>
    api.put(`/deals/${id}`, data);

    export const deleteDeal = (id) =>
    api.delete(`/deals/${id}`);

    export const bulkDeleteDeals = (dealIds) =>
  api.delete("/deals/bulk/delete", {
    data: {
      dealIds,
    },
  });

    export const bulkAssignDeals = (dealIds, assigned_to) =>
    api.put("/deals/bulk/assign", {
      dealIds,
      assigned_to,
    });

    export const getLeadComments = (id)=>
    api.get(`/leads/${id}/comments`);

    export const createLeadComment = (id,data)=>
    api.post(`/leads/${id}/comments`,data);
  export const getDealComments = (id) =>
    api.get(`/deals/${id}/comments`);

  export const createDealComment = (id, data) =>
    api.post(`/deals/${id}/comments`, data);

  // ======================================
  // DEAL STAGES
  // ======================================

  export const getDealStages = (includeInactive = false) =>
    api.get("/deal-stages", {
      params: {
        include_inactive: includeInactive,
      },
    });

  export const createDealStage = (display_name, color = "#2563eb") =>
    api.post("/deal-stages", {
      display_name,
      color,
    });

  export const updateDealStage = (
    id,
    display_name,
    color
  ) =>
    api.put(`/deal-stages/${id}`, {
      display_name,
      color,
    });

  export const updateDealStageStatus = (id, is_active) =>
    api.patch(`/deal-stages/${id}/status`, {
      is_active,
    });

  export const reorderDealStages = (stages) =>
    api.patch("/deal-stages/reorder/all", {
      stages: stages.map((stage) => ({
        id: stage.id,
      })),
    });

  export const deleteDealStage = (id) =>
    api.delete(`/deal-stages/${id}`);


  // ======================================
  // LEAD STAGES
  // ======================================

  export const getLeadStages = (includeInactive = false) =>
    api.get("/lead-stages", {
      params: {
        include_inactive: includeInactive,
      },
    });

  export const createLeadStage = (
    display_name,
    color = "#64748b"
  ) =>
    api.post("/lead-stages", {
      display_name,
      color,
    });

  export const updateLeadStage = (
    id,
    display_name,
    color
  ) =>
    api.put(`/lead-stages/${id}`, {
      display_name,
      color,
    });

  export const updateLeadStageStatus = (id, is_active) =>
    api.patch(`/lead-stages/${id}/status`, {
      is_active,
    });

  export const reorderLeadStages = (stages) =>
    api.patch("/lead-stages/reorder/all", {
      stages: stages.map((stage) => ({
        id: stage.id,
      })),
    });

  export const deleteLeadStage = (id) =>
    api.delete(`/lead-stages/${id}`);
  // ======================================
// PIPELINE STAGES
// ======================================

export const getPipelineStages = () =>
  api.get("/pipeline-stages");

export const updatePipelineStage = (
  id,
  display_name,
  color
) =>
  api.put(`/pipeline-stages/${id}`, {
    display_name,
    color,
  });

  // Sources
  export const getSources = () =>
    api.get("/sources");

  export const createSource = (source_name) =>
    api.post("/sources", { source_name });

  export const updateSource = (id, source_name) =>
    api.put(`/sources/${id}`, { source_name });

  export const deleteSource = (id) =>
    api.delete(`/sources/${id}`);


  // ======================================
  // DEAL LOST REASONS
  // ======================================

  export const getDealLostReasons = () =>
    api.get("/deal-lost-reasons");

  export const createDealLostReason = (reason) =>
    api.post("/deal-lost-reasons", {
      reason,
    });

  export const updateDealLostReason = (id, reason) =>
    api.put(`/deal-lost-reasons/${id}`, {
      reason,
    });

  export const deleteDealLostReason = (id) =>
    api.delete(`/deal-lost-reasons/${id}`);

  export const bulkUpdateLeadStage = (leadIds, stage) =>
    api.put("/leads/bulk/update-stage", {
      leadIds,
      stage,
    });

    export const bulkUpdateLeadSource = (leadIds, source) =>
    api.put("/leads/bulk/update-source", {
      leadIds,
      source,
    });

    export const bulkAssignLeads = (leadIds, assigned_to) =>
  api.put("/leads/bulk/assign", {
    leadIds,
    assigned_to,
  });

  export const bulkDeleteLeads = (leadIds) =>
  api.delete("/leads/bulk/delete", {
    data: {
      leadIds,
    },
  });


  // ======================================
  // DROP REASONS
  // ======================================

  export const getDropReasons = () =>
    api.get("/drop-reasons");

  export const createDropReason = (reason) =>
    api.post("/drop-reasons", {
      reason,
    });

  export const updateDropReason = (id, reason) =>
    api.put(`/drop-reasons/${id}`, {
      reason,
    });

  export const deleteDropReason = (id) =>
    api.delete(`/drop-reasons/${id}`);

  export const restoreDroppedLeads = (leadIds) =>
    api.put("/leads/dropped/restore", {
      leadIds,
    });

  export const assignDroppedLeads = (leadIds, assigned_to) =>
    api.put("/leads/dropped/assign", {
      leadIds,
      assigned_to,
    });

    export const bulkDeleteDroppedLeads = (leadIds) =>
  api.delete("/leads/dropped/bulk/delete", {
    data: {
      leadIds,
    },
  });

export const getLeadTimeline = (leadId) =>
  api.get(`/leads/${leadId}/timeline`);

// ======================================
// EXPORT
// ======================================

export const exportLeads = (params) =>
  api.get("/export/leads", {
    params,
    responseType: "blob",
  });

export const exportDrops = (params) =>
  api.get("/export/drops", {
    params,
    responseType: "blob",
  });

export const exportTasks = (params) =>
  api.get("/export/tasks", {
    params,
    responseType: "blob",
  });

export const exportActivityTimeline = (params) =>
  api.get("/export/activity", {
    params,
    responseType: "blob",
  });

// ======================================
// GLOBAL CRM SEARCH
// ======================================

export const globalSearch = (searchText) =>
  api.get("/search", {
    params: {
      q: String(searchText || "").trim(),
    },
  });

    export default api;
